import { render, staticRenderFns } from "./ProfilePagePassword.vue?vue&type=template&id=4720be2c&"
import script from "./ProfilePagePassword.vue?vue&type=script&lang=js&"
export * from "./ProfilePagePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports